/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { AcceptInvitationByIdMutationResponse, AcceptInvitationByIdPathParams, AcceptInvitationById400, AcceptInvitationById401, AcceptInvitationById403, AcceptInvitationById404, AcceptInvitationById409, AcceptInvitationById500 } from "../../types/staffController/AcceptInvitationById.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getAcceptInvitationByIdUrl(invitationId: AcceptInvitationByIdPathParams["invitationId"]) {
  const res = { method: 'POST', url: `/api/invitations/${invitationId}/accept` as const }
  return res
}

/**
 * @summary Accept one of the signed-in user's pending invitations
 * {@link /api/invitations/:invitationId/accept}
 */
export async function acceptInvitationById(invitationId: AcceptInvitationByIdPathParams["invitationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AcceptInvitationByIdMutationResponse, ResponseErrorConfig<AcceptInvitationById400 | AcceptInvitationById401 | AcceptInvitationById403 | AcceptInvitationById404 | AcceptInvitationById409 | AcceptInvitationById500>, unknown>({ method : "POST", url : getAcceptInvitationByIdUrl(invitationId).url.toString(), ... requestConfig })
  return res.data
}